quoteModule.controller('lendersModalInstanceController',
    ['$rootScope', '$scope', '$mdDialog', 'lenderId', 'lenderRetrievalService', 
    'commonTLCService', 'LenderInfo','TLCError','AppErrorCodes', 'erateSessionVarsService', 'imSessionVarsService',
        function ($rootScope, $scope, $mdDialog, lenderId, lenderRetrievalService, commonTLCService, LenderInfo,  
            TLCError, AppErrorCodes, erateSessionVarsService, imSessionVarsService) {

            $scope.ProvdersThatRequireLendersFromThem = ['PREMIER'];

            $scope.states = [];
            $scope.lenderId = lenderId;
            $scope.providerCode = null;
            $scope.providerLimited = false;
            $scope.providerLenderChosen = false;
            $scope.dealerId = null;
            $scope.chosenProviderLender = null;
            $scope.providerLenders = [];
            $scope.menuDealerId = '0';
            $scope.menuLenders = [];
            $scope.chosenMenuLender = '';
            $scope.editLender = {};
            // SSO from Showcase - If we inline the error messages in the markup, they 'flash' for a few milliseconds which is why we are using an object instead and setting timeOut
            $scope.errorMessages = {
				lenderName: {
					a: '', b: ''
				},
	            lenderCode: {
					a: '', b: ''
	            },
	            addressOne: {
					a: '', b: ''
	            },
	            addressTwo: {
					a: ''
	            },
	            city: {
					a: '', b: ''
	            },
	            zip: {
					a: ''
	            },
	            phone: {
					a: '', b: ''
	            }
            };

            function init() {
                //get states list
                commonTLCService.getStates()
                    .then(function(response){
                        $scope.states = response;
                     }, function(response, status, headers, config){
                        throw new TLCError(new Error(response),AppErrorCodes.LenderController_LoadStatesError);
                    });
                fillScope();

                setTimeout(function(){
                	fillErrorMessages();
                }, 500);

                $scope.providerCode = imSessionVarsService.getCurrentProviderCode();
                $scope.dealerId = erateSessionVarsService.getCurrentDealerSPANId();
                $scope.providerLimited = $scope.ProvdersThatRequireLendersFromThem.indexOf($scope.providerCode.toUpperCase()) >= 0;
                if ($scope.providerLimited) {
                    getProviderLenders();
                }
                $scope.menuDealerId = erateSessionVarsService.getCurrentDealerMenuProId();
                $scope.menuLenders = [];
                if (parseInt($scope.menuDealerId || '0') > 0 && $scope.providerCode.toUpperCase() === 'PREMIER') {
                    getMenuProLenders()
                }
            }

            init();

            //save button click - Add or Update a lender
            $scope.ok = function () {
                //getting around validation for provider-defined lenders
                if ($scope.providerLenderChosen) {
                    if ($scope.editLender.address1 == 'UNKNOWN') { $scope.editLender.address1 = ''; }
                    if ($scope.editLender.city == 'UNKNOWN') { $scope.editLender.city = ''; }
                    if ($scope.editLender.zip == '00000') { $scope.editLender.zip = ''; }
                }
                lenderRetrievalService.saveLender($scope.editLender)
                .then(
                    function (response) {
                        //refresh the lenders list
                        $rootScope.$broadcast('refreshLenders');
                        $mdDialog.hide();
                    }, function (err) {
                        throw new TLCError(new Error(err),AppErrorCodes.LenderController_SaveLendersError);
                });
            };

            //cancel button click
            $scope.cancel = function () {
                //refresh the lenders list
                $rootScope.$broadcast('refreshLenders');
                $mdDialog.cancel();
            };

            $scope.isAllDataCheck = function(){
                return ($scope.lenderEdit_form.lenderCode.$valid
                    &&
                    $scope.lenderEdit_form.lenderName.$valid
                    &&
                    $scope.lenderEdit_form.address1.$valid
                    &&
                    $scope.lenderEdit_form.city.$valid
                    &&
                    $scope.lenderEdit_form.zip.$valid
                    &&
                    $scope.lenderEdit_form.phone.$valid
                )
            };

            function getProviderLenders() {
                lenderRetrievalService.getProviderSpecificLenders($scope.providerCode, $scope.dealerId)
                .then(function(data) {
                    $scope.providerLenders = data;
                })
            }

            function getMenuProLenders() {
                lenderRetrievalService.getMenuLenders($scope.menuDealerId)
                .then(function(data) {
                    $scope.menuLenders = data;
                })
            }

            $scope.changeProviderLender = function(chosenprovldrid) {
                const chosen = _.find($scope.providerLenders, function(element) {  return element.Value === chosenprovldrid; });
                if (chosen) {
                    $scope.editLender = new LenderInfo();
                    $scope.editLender.code = "";
                    $scope.editLender.name = chosen.Full.Name;
                    $scope.editLender.address1 = (chosen.Full.Address1).length > 0 ? chosen.Full.Address1 : 'UNKNOWN';
                    $scope.editLender.address2 = chosen.Full.Address2;
                    $scope.editLender.city = (chosen.Full.City).length > 0 ? chosen.Full.City : 'UNKNOWN';
                    $scope.editLender.state = chosen.Full.State;
                    $scope.editLender.zip = (chosen.Full.Zip).length > 0 ? chosen.Full.Zip.replace('-', '') : '00000';
                    $scope.editLender.spanDealerId = $scope.dealerId;
                    $scope.editLender.isDefault = false;
                    $scope.editLender.providerMandatoryLenderId = 0;
                    $scope.editLender.providerSpecificCode = chosenprovldrid;
                    $scope.chosenProviderLender = chosenprovldrid;                
                    $scope.providerLenderChosen = true;
                } else {
                    $scope.providerLenderChosen = false;
                }
            }

            $scope.changeMenuLender = function(val) {
                $scope.editLender.code = val;
            }

            //fill the scope variables
            function fillScope() {
                if (!($scope.lenderId)) {
                    //no id.. new lender
                   $scope.editLender = new LenderInfo();
                }
                else {
                    //retrieve the lender by id
                    lenderRetrievalService.getLenderById($scope.lenderId)
                        .then(
                            function (response) {
                                $scope.editLender = response;
                                $scope.providerLenderChosen = ($scope.editLender.providerSpecificCode || '').length > 0;
                                $scope.chosenProviderLender = ($scope.editLender.providerSpecificCode || '');
                                if ($scope.providerLenderChosen) {
                                    $scope.editLender.address1 = ($scope.editLender.address1).length > 0 ? $scope.editLender.address1 : 'UNKNOWN';
                                    $scope.editLender.city = ($scope.editLender.city).length > 0 ? $scope.editLender.city : 'UNKNOWN';
                                    $scope.editLender.zip = ($scope.editLender.zip).length > 0 ? $scope.editLender.zip : '00000';
                                }
                                if (parseInt($scope.menuDealerId || '0') > 0) {
                                    $scope.chosenMenuLender = response.code;
                                }
                            }, function (err) {
                                throw new TLCError(new Error(err),AppErrorCodes.LenderController_GetALenderError);
                            }
                        );
                }
            }

            function fillErrorMessages(){
	            $scope.errorMessages = {
		            lenderName: {
		            	a: 'Lender name is required.',
			            b: 'Lender name is too long.'
		            },
		            lenderCode: {
		            	a: 'Lender code is required.',
			            b: 'Lender code is too long.'
		            },
		            addressOne: {
		            	a: 'Address is required.',
			            b: 'Address is too long.'
		            },
		            addressTwo: {
			            a: 'Address is too long.'
		            },
		            city: {
		            	a: 'City is required.',
			            b: 'City is too long.'
		            },
		            zip: {
		            	a: 'Must be a valid ZIP.'
		            },
		            phone: {
		            	a: 'Must be a valid phone number.',
                        b: 'Phone is invalid.'
		            },
	            };
            }
}]);
